let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4EmhV")).then(() => parcelRequire('eWn4R'));